document.addEventListener("DOMContentLoaded", () => {
  initHelpCenter();
});

document.addEventListener("click", (e) => {
  const dropdown = document.getElementById("hc-dropdown");
  const dropdownList = document.getElementById("hc-dropdownList");
  if (dropdown && dropdownList && !dropdown.contains(e.target)) {
    dropdownList.style.display = "none";
  }
});

const BASE = "https://tbf-cd446fc00dcd.herokuapp.com/api/zendesk";
const locale = Shopify.locale;
const content = document.getElementById("hc-dynamic-container");
const titleEl = document.getElementById("hc-title");
const searchInput = document.getElementById("hc-search-input");

const ICON_BASE = window.__HC_ICON_BASE__ || "";
const CACHE_KEY = "helpCategories";
const CACHE_TTL = 5 * 60 * 1000;

let allCategories = [];
let hasVisitedHome = false;

// ------------------------------------ UTIL
function slugify(str) {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function goToCategory(id) {
  if (!id) return;
  window.location.hash = `#categoria/${id}`;
}

// ------------------------------------ INIT
async function initHelpCenter() {
  searchInput.addEventListener("input", () => {
    const q = searchInput.value.trim();
    const dropDownList = document.getElementById("hc-dropdownList");

    if (q.length > 1) {
      searchArticles(q);
      dropDownList.style = "display:block;";
    } else {
      dropDownList.style.display = "none";
      if (!hasVisitedHome) {
        renderHome(allCategories);
      }
    }
  });

  document.querySelector(".hc-icon-right").addEventListener("click", () => {
    const query = searchInput.value.trim();
    if (query.length > 2) {
      const dropDownList = document.getElementById("hc-dropdownList");
      dropDownList.style.display = "none";
      triggerFullSearch(query, true);
    }
  });

  let currentDropdownIndex = -1;

  searchInput.addEventListener("keydown", (e) => {
    const dropDownList = document.getElementById("hc-dropdownList");
    const items = dropDownList.querySelectorAll("#hc-dropdownList li");

    if (["ArrowDown", "ArrowUp", "Enter"].includes(e.key) && items.length > 0) {
      e.preventDefault();

      if (e.key === "ArrowDown") {
        currentDropdownIndex = (currentDropdownIndex + 1) % items.length;
      } else if (e.key === "ArrowUp") {
        currentDropdownIndex = (currentDropdownIndex - 1 + items.length) % items.length;
      } else if (e.key === "Enter" && currentDropdownIndex >= 0) {
        const anchor = items[currentDropdownIndex].querySelector("a");
        if (anchor) anchor.click();
        return;
      }

      items.forEach((item, i) => {
        item.classList.toggle("active", i === currentDropdownIndex);

        const anchor = item.querySelector("a");
        if (anchor) {
          anchor.setAttribute("aria-selected", i === currentDropdownIndex);
        }
      });

      // Asegurar que el item activo se vea (scroll)
      const activeItem = items[currentDropdownIndex];
      if (activeItem) activeItem.scrollIntoView({ block: "nearest" });
    } else if (e.key === "Enter") {
      // Enter sin navegar por el dropdown: búsqueda completa
      const query = searchInput.value.trim();
      dropDownList.style.display = "none";
      triggerFullSearch(query, true);
    } else if (e.key === "Escape") {
      dropDownList.style.display = "none";
      currentDropdownIndex = -1;

      // Quitar clase activa de todos los ítems
      items.forEach((item) => {
        item.classList.remove("active");
        item.removeAttribute("aria-selected");
      });
    }
  });

  const cached = localStorage.getItem(CACHE_KEY);
  if (cached) {
    try {
      const { timestamp, categories } = JSON.parse(cached);
      if (Date.now() - timestamp < CACHE_TTL) {
        allCategories = categories;
        if (!window.location.hash) {
          renderHome(categories);
        }
      }
    } catch {}
  }

  try {
    const res = await fetch(`${BASE}/hc/categories?locale=${locale}&action=loadCats`);
    if (!res.ok) throw new Error(res.status);
    const categories = await res.json();
    allCategories = categories;

    localStorage.setItem(CACHE_KEY, JSON.stringify({ timestamp: Date.now(), categories }));

    if (!window.location.hash) {
      renderHome(categories);
    }
  } catch (err) {
    console.error("Error cargando categorías:", err);
    content.innerHTML = `<p>Error cargando categorías.</p>`;
  }

  // ✅ Escuchar cambios de hash solo una vez que esté todo listo
  window.addEventListener("hashchange", handleHashRoute);
  handleHashRoute(); // ✅ Ejecutar al final
}

function triggerFullSearch(query, renderAllToMain = false) {
  if (!query) return;

  hasVisitedHome = true;
  renderLayout();
  renderSidebar(allCategories);
  searchArticles(query, { renderAllToMain });

  // Ocultar dropdown
  const dropdownList = document.getElementById("hc-dropdownList");
  if (dropdownList) dropdownList.style.display = "none";
}

function handleHashRoute() {
  if (!allCategories.length) {
    // Esperar y reintentar si las categorías aún no están cargadas
    setTimeout(handleHashRoute, 100);
    return;
  }

  const hash = window.location.hash.replace(/^#/, "");
  const [route, param] = hash.split("/");

  if (!route) {
    hasVisitedHome = false;
    renderHome(allCategories);
    return;
  }

  switch (route) {
    case "categoria": {
      const catId = Number(param);
      const cat = allCategories.find((c) => c.id === catId);
      if (cat) {
        renderLayout();
        renderSidebar(allCategories, cat.id);
        loadCategoryArticles(cat);
      }
      break;
    }

    case "buscar": {
      const query = decodeURIComponent(param || "");
      if (query) {
        hasVisitedHome = true;
        triggerFullSearch(query, true); // renderiza búsqueda completa
      }
      break;
    }

    case "articulo": {
      const articleId = param;
      const articleData = findArticleById(articleId);

      // Limpiar la ID si no hay zendeskId cacheado
      let zendeskId = articleData?.zendeskId;
      if (!zendeskId) {
        // Extraer solo la parte numérica del ID
        const match = articleId.match(/^\d+/);
        if (match) zendeskId = match[0];
        else {
          console.error("ID de artículo no válida:", articleId);
          return;
        }
      }

      if (
        articleData &&
        typeof articleData === "object" &&
        articleData.body &&
        articleData.title &&
        articleData.category &&
        articleData.category.id
      ) {
        const { body, category, title } = articleData;
        hasVisitedHome = true;
        renderLayout();
        renderSidebar(allCategories, category.id);
        renderArticle(body, category, "", title);
      } else {
        // 🚀 Si no está cacheado, lo pedimos al backend por ID
        fetch(`${BASE}/hc/categories?action=getArticleById&id=${zendeskId}&locale=${locale}`)
          .then((res) => {
            if (!res.ok) throw new Error(res.status);
            return res.json();
          })
          .then((data) => {
            const { body, title, category } = data;

            // Guardar en caché
            saveArticleToCache(articleId, { zendeskId, body, title, category });

            hasVisitedHome = true;
            renderLayout();
            renderSidebar(allCategories, category.id);
            renderArticle(body, category, "", title);
          })
          .catch((err) => {
            console.error("Error cargando artículo por ID:", err);
            content.innerHTML = `<p>Error al cargar el artículo.</p>`;
          });
      }
      break;
    }

    default:
      renderHome(allCategories);
  }
}

// ------------------------------------ HOME
function renderHome(categories) {
  if (!categories || !categories.length) return;
  const lang = ["es", "fr", "pt"].includes(Shopify.locale) ? Shopify.locale : "es";

  const introText = {
    es: `En esta sección encontrarás respuestas a las dudas más frecuentes.
        Si necesitas ayuda <br>adicional, no dudes en <a style="color: inherit;cursor: pointer;" href="/pages/contact">contactar con nuestro equipo</a>.`,
    fr: `Dans cette section, vous trouverez des réponses aux questions les plus fréquentes.
        Si vous avez besoin d'aide supplémentaire, n'hésitez pas à <a style="color: inherit;cursor: pointer;" href="/pages/contact">contacter notre équipe</a>.`,
    pt: `Nesta secção encontrará respostas às perguntas mais frequentes.
        Se precisar de ajuda adicional, não hesite em <a style="color: inherit;cursor: pointer;" href="/pages/contact">contactar a nossa equipa</a>.`,
  };

  if (!hasVisitedHome) {
    renderLayout();
    updateBreadcrumb({});
  }

  if (window.matchMedia("(max-width: 768px)").matches) {
    const html = categories
      .map((cat) => {
        const nameMap = {
          "mis pedidos": "Pedidos",
          "preguntas frecuentes": "FAQs",
          "plazos de entrega": "Entrega",
          "question fréquentes": "FAQs",
          "mes commandes": "Commandes",
          "délais de livraison": "Livraison",
        };
        const displayName = nameMap[cat.name.toLowerCase()] || cat.name;

        return `
          <div class="hc-card" data-id="${cat.id}" style="display:flex;align-items: center; gap: 15px; padding:1.5rem; border-radius: 5px; min-height:100px;">
            <img height="32" width="32" src="https://cdn.shopify.com/s/files/1/0876/0334/7777/files/${cat.id}.png">
            <div style="text-align:start;"> 
              <h3 class="hc-cat-title" style="font-size:2.5rem;margin-bottom:5px;">${displayName}</h3>
              <p class="hc-cat-desc" style="margin-bottom:0;">${cat.description}</p>
            </div>
          </div>
        `;
      })
      .join("");

    content.querySelector("#hc-articles").style = "padding:0;";
    const title = document.querySelector(".hc-title");
    if (title) title.style = "font-size:32px;";
    content.querySelector("#hc-layout").style = "gap:0;";
    content.querySelector("#hc-articles").innerHTML = `
      <div>
        <p style="margin-bottom: 4px;text-align: start;background: #daefff;padding: 13px;border-radius: 5px;box-shadow: 1px 1px 9px #fff0f0;" id="hc-subtitle" class="hc-title">
          ${introText[lang]}
        </p>
        <div class="hc-home-grid" style="display:flex; flex-direction: column;gap: 10px;">${html}</div>
      </div>`;

    content.querySelectorAll(".hc-card").forEach((card) => {
      card.addEventListener("click", () => {
        const id = Number(card.dataset.id);
        goToCategory(id);
      });
    });
  } else {
    const html = categories
      .map(
        (cat) => `
        <div class="hc-card" data-id="${cat.id}">
          <img height="46" width="46" src="https://cdn.shopify.com/s/files/1/0876/0334/7777/files/${cat.id}.png">
          <h3 class="hc-cat-title">${cat.name}</h3>
          <p class="hc-cat-desc">${cat.description}</p>
        </div>
      `
      )
      .join("");

    content.querySelector("#hc-articles").innerHTML = `
      <div>
        <p style="margin-bottom: 4px;padding: 13px;" id="hc-subtitle" class="hc-title">${introText[lang]}</p>
        <div class="hc-home-grid">${html}</div>
      </div>`;

    content.querySelectorAll(".hc-card").forEach((card) => {
      card.addEventListener("click", () => {
        const id = Number(card.dataset.id);
        goToCategory(id);
      });
    });
  }
}

// ------------------------------------ LAYOUT
function renderLayout() {
  content.innerHTML = `
    <div class="hc-breadcrumb-wrapper" style="width: 100%;">
      <nav id="hc-breadcrumb" class="hc-breadcrumb"></nav>
    </div>
    <div class="hc-layout" id="hc-layout">
      <aside class="hc-menu"><div class="hc-sidebar"></div></aside>
      <main id="hc-articles" class="hc-main"></main>
    </div>
  `;
}

function updateBreadcrumb({ category = null, articleTitle = null }) {
  const breadcrumb = document.getElementById("hc-breadcrumb");
  if (!breadcrumb) return;
  const hcTranslations = {
    es: { helpCenter: "Centro de ayuda" },
    fr: { helpCenter: "Centre d'aide" },
    pt: { helpCenter: "Centro de ajuda" },
  };
  const lang = ["es", "fr", "pt"].includes(Shopify.locale) ? Shopify.locale : "es";
  const helpCenterLabel = hcTranslations[lang].helpCenter;

  let html = `
    <a href="/" class="hc-breadcrumb__link" style="text-decoration: none; color: #666;">TheBath</a>
    &nbsp;&gt;&nbsp;
    <a href="#" id="hc-breadcrumb-home" class="hc-breadcrumb__link" style="text-decoration: none; color: #666;">${helpCenterLabel}</a>
  `;

  if (category) {
    html += `&nbsp;&gt;&nbsp;
      <a href="#" id="hc-breadcrumb-category" class="hc-breadcrumb__link" style="text-decoration: none; color: #666;">${category.name}</a>`;
  }

  if (articleTitle) {
    html += `&nbsp;&gt;&nbsp;<strong style="color: #000;">${articleTitle}</strong>`;
  }

  breadcrumb.innerHTML = html;

  // Eventos de navegación
  const homeLink = document.getElementById("hc-breadcrumb-home");
  if (homeLink) {
    homeLink.addEventListener("click", (e) => {
      e.preventDefault();
      hasVisitedHome = false;
      renderHome(allCategories);
    });
  }

  const categoryLink = document.getElementById("hc-breadcrumb-category");
  if (categoryLink && category) {
    categoryLink.addEventListener("click", (e) => {
      e.preventDefault();
      goToCategory(category.id); // usar el router/hash
    });
  }
}

// ------------------------------------ SIDEBAR
function renderSidebar(categories, activeCategoryId = null) {
  const sidebar = content.querySelector(".hc-sidebar");
  if (!sidebar || !categories) return;

  function normalizeKey(str) {
    return str.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
  }

  const nameMap = {
    "mis pedidos": "Pedidos",
    "preguntas frecuentes": "FAQs",
    "plazos de entrega": "Entrega",
    "questions frequentes": "FAQs", // "questions fréquentes"
    "mes commandes": "Commandes",
    "delais de livraison": "Livraison", // "délais de livraison"
  };

  sidebar.innerHTML = categories
    .map((cat) => {
      const key = normalizeKey(cat.name);
      const displayName = nameMap[key] || cat.name;
      const isActive = cat.id === activeCategoryId ? "active" : "";

      return `<div class="hc-sec ${isActive}" data-id="${cat.id}">
        <img height="32" width="32" src="https://cdn.shopify.com/s/files/1/0876/0334/7777/files/${cat.id}.png">
        <span>${displayName}</span>
      </div>`;
    })
    .join("");

  sidebar.querySelectorAll(".hc-sec").forEach((el) => {
    el.addEventListener("click", () => {
      const id = Number(el.dataset.id);
      goToCategory(id); // unificado con helper
    });
  });
}

// ------------------------------------ LOAD CATEGORY ARTICLES
async function loadCategoryArticles(category) {
  const target = document.getElementById("hc-articles");
  if (!category || !target) return;
  if (titleEl) titleEl.textContent = category.name;

  updateBreadcrumb({ category });
  showSkeletonLoader();

  const sections = category.sections;
  if (!sections || !sections.length) {
    target.innerHTML = "<p>Esta categoría no tiene artículos disponibles.</p>";
    return;
  }

  try {
    // Fetch todos los artículos de todas las secciones
    const allArticlesPromises = sections.map((section) =>
      fetch(`${BASE}/hc/categories?locale=${locale}&action=loadArticles&section=${section.id}`)
        .then((res) => res.json())
        .then((data) => ({
          sectionName: section.name,
          articles: Array.isArray(data.articles) ? data.articles : data,
        }))
    );

    const articlesBySection = await Promise.all(allArticlesPromises);

    // Renderizado
    target.innerHTML =
      `<h3 style="font-weight:bold;">${category.name}</h3>
      <p style="font-style:italic; margin-bottom:20px;">${category.description}</p>` +
      articlesBySection
        .map(({ sectionName, articles }) => {
          if (!articles.length) return "";

          const articleList = articles
            .map((a) => {
              const articleId = String(a.id);
              // Guardar en caché para navegación directa por hash
              saveArticleToCache(articleId, {
                zendeskId: a.id, // ID real de Zendesk
                body: a.body,
                title: a.title,
                category,
              });

              return `<li>
                <a class="hc-article__title" href="#articulo/${articleId}">${a.title}</a>
              </li>`;
            })
            .join("");

          return `
            <section>
              <h5>${sectionName}</h5>
              <ul class="articles-list">${articleList}</ul>
            </section>
          `;
        })
        .join("");
  } catch (err) {
    console.error("Error al cargar artículos:", err);
    target.innerHTML = `<p>Error al cargar los artículos.</p>`;
  }
}

function generateArticleId(categoryId, title) {
  return `${categoryId}-${slugify(title)}`;
}

function saveArticleToCache(id, data) {
  const cache = JSON.parse(localStorage.getItem("hcArticleCache") || "{}");
  cache[id] = data;
  localStorage.setItem("hcArticleCache", JSON.stringify(cache));
}

function findArticleById(id) {
  const cache = JSON.parse(localStorage.getItem("hcArticleCache") || "{}");
  return cache[id] || null;
}

// ------------------------------------ RENDER ARTICLE
function renderArticle(html, category, searchTerm = "", title = "") {
  if (!hasVisitedHome) {
    hasVisitedHome = true;
    renderLayout();
    renderSidebar(allCategories, category?.id); // usar id activo
  }

  const target = document.getElementById("hc-articles");
  if (!target) return;

  // Resaltar términos si hay búsqueda
  if (searchTerm) {
    const terms = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
    let pattern = terms.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");
    pattern = new RegExp(`(?<!<[^>]*)\\b(${pattern})\\b(?![^<]*>)`, "gi");
    html = html.replace(pattern, '<span class="highlight">$1</span>');
  }

  // Actualizar breadcrumb
  updateBreadcrumb({ category, articleTitle: title });

  // Render del artículo
  target.innerHTML = `
    <p><a href="#" class="hc-back-section">← Volver</a></p>
    ${title ? `<h3>${title}</h3>` : ""}
    <article class="hc-article-content">${html}</article>
  `;

  // Botón volver
  target.querySelector(".hc-back-section").addEventListener("click", (e) => {
    e.preventDefault();
    if (category) {
      loadCategoryArticles(category);
    } else {
      renderSidebar(allCategories);
    }
  });
}

// ------------------------------------ SEARCH
async function searchArticles(query, { renderAllToMain = false } = {}) {
  if (!query) return;
  if (titleEl) titleEl.textContent = `Resultados para “${query}”`;
  const dropDownList = document.getElementById("hc-dropdownList");
  dropDownList.innerHTML = `<p style="padding:5px;">Buscando…</p>`;

  try {
    const res = await fetch(`${BASE}/hc/categories?locale=${locale}&action=search&query=${query}`);
    if (!res.ok) throw new Error(res.status);
    const results = await res.json();

    const terms = query.toLowerCase().split(/\s+/).filter(Boolean);
    let pattern = terms.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");
    const regex = new RegExp(`(${pattern})`, "gi");

    const listItems = results.map((r, index) => {
      const cleanTitle = r.title.replace(/^\d+\.\s*/, "");
      const highlightedTitle = cleanTitle.replace(regex, '<span class="highlight">$1</span>');
      const articleId = `${r.id}-${slugify(r.title)}`;
      return `
        <li>
          <a class="hc-dropdown__item" 
             href="#" 
             data-index="${index}"
             data-body="${encodeURIComponent(r.body)}" 
             data-title="${r.title}" 
             data-category-id="${r.category_id}"
             data-article-id="${articleId}">
            ${highlightedTitle}
          </a>
        </li>`;
    });

    dropDownList.innerHTML = results.length ? listItems.join("") : `<p>No se encontraron artículos.</p>`;
    dropDownList.style.display = "block";

    // Navegación por hash al hacer click en un resultado del dropdown
    const links = dropDownList.querySelectorAll("a.hc-dropdown__item");
    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const articleId = link.dataset.articleId;
        if (articleId) {
          hasVisitedHome = true;
          dropDownList.style.display = "none";
          window.location.hash = `#articulo/${articleId}`;
        }
      });
    });

    // Mostrar todos los resultados en el layout
    if (renderAllToMain && results.length) {
      dropDownList.style.display = "none";

      renderLayout();
      renderSidebar(allCategories);
      const articlesHTML = results
        .map(
          (r) => `
        <li>
          <a class="hc-article__title" 
             href="#" 
             data-body="${encodeURIComponent(r.body)}" 
             data-title="${r.title}" 
             data-category-id="${r.category_id}">
            ${r.title}
          </a>
        </li>`
        )
        .join("");

      document.getElementById("hc-articles").innerHTML = `
        <h3 style="font-weight:bold;">Resultados de búsqueda</h3>
        <ul class="articles-list">${articlesHTML}</ul>
      `;

      document.querySelectorAll(".hc-article__title").forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          const body = decodeURIComponent(link.dataset.body);
          const title = link.dataset.title;
          const categoryId = Number(link.dataset.categoryId);
          const realCategory = allCategories.find((c) => c.id === categoryId);
          renderArticle(body, realCategory, query, title);
        });
      });
    }
  } catch (err) {
    console.error("Error en búsqueda:", err);
    content.innerHTML = `<p>Error al realizar la búsqueda.</p>`;
  }
}

function showSkeletonLoader(count = 6) {
  const target = document.getElementById("hc-articles");
  if (!target) return;

  const skeletonLines = Array.from({ length: count }, () => `<div class="skeleton skeleton-line">&nbsp;</div>`).join("");

  const html = `
    <div class="skeleton-wrapper">
      <div class="skeleton skeleton-title">&nbsp;</div>
      ${skeletonLines}
    </div>
  `;

  // Asegurar visibilidad del contenedor
  target.style.minHeight = "150px";
  target.innerHTML = html;
}
